import Vue from 'vue';
import { MutationTree } from 'vuex';
import { Campus, City, LocationState } from './state';

const mutations: MutationTree<LocationState> = {
  SET_CITY(state, city: City) {
    state.city = city;
  },
  SET_CAMPUS(state, campus: Campus) {
    state.campus = campus;
  },
  SET_AVAILABLE_CITIES(state, availableCities: string[]) {
    state.availableCities = availableCities;
  },
  SET_AVAILABLE_CAMPUSES(state, availableCampuses: Campus[]) {
    state.availableCampuses = availableCampuses;
  },
  SET_CAMPUS_DETAILS(state, campusDetails: Campus) {
    state.campusDetails = campusDetails;
  },
};

export default mutations;
